import React from 'react';
import { cn } from '../../lib/utils';
import { Sun, Moon, Monitor } from 'lucide-react';
import { useTheme } from '../../theme/ThemeContext';

export function ThemeToggle({ className = '' }) {
  const { theme, resolvedTheme, setTheme } = useTheme();

  const cycleTheme = () => {
    if (theme === 'light') setTheme('dark');
    else if (theme === 'dark') setTheme('system');
    else setTheme('light');
  };

  const getIcon = () => {
    if (theme === 'system') return <Monitor className="w-4 h-4" />;
    if (resolvedTheme === 'dark') return <Moon className="w-4 h-4" />;
    return <Sun className="w-4 h-4" />;
  };

  const getLabel = () => {
    if (theme === 'system') return 'System theme';
    if (theme === 'dark') return 'Dark theme';
    return 'Light theme';
  };

  return (
    <button
      type="button"
      onClick={cycleTheme}
      className={cn('inline-flex items-center justify-center w-8 h-8 rounded-md bg-transparent text-[var(--fg-secondary)] hover:text-[var(--fg-primary)] hover:bg-[var(--bg-hover)] transition-colors cursor-pointer', className)}
      aria-label={`Current theme: ${getLabel()}. Click to change.`}
      title={`Theme: ${theme}`}
    >
      {getIcon()}
    </button>
  );
}

export default ThemeToggle;
